import styled from '@emotion/styled'
import { theme } from '@dasa-health/components-react'

export const WrapperFildUpdateContacts = styled.div`
    margin-bottom: 2rem;
    margin-top: 1.5rem;
    &::last-child {
        margin-top: 0;
    }
`

export const Container = styled.div`
    margin-top: 1rem;
    padding: 1.5rem;
    border-radius: 0.25rem;
    background: #f1f5fe;
    margin-top: 24px;
    margin-bottom: 2rem;
`

export const Title = styled.h1`
    color: #161616;
    font-size: 1rem;
    font-weight: 500;
    line-height: 150%; /* 1.5rem */
    display: flex;
    align-items: center;
    justify-content: flex-start;

    & svg {
        margin-right: 0.5rem;
    }
`

export const Text = styled.p`
    color: #666;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 170%; /* 1.4875rem */
    margin: 0.5rem 0;
`

export const ContainerButtons = styled.div`
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0.5rem;
    @media screen and (min-width: ${theme.breakpoints[0]}) {
        position: sticky;
        margin: 0;
        padding: 0;
    }
`
